<template>
  <div id="app">
    <navbar-main/>

    <router-view/>
  </div>
</template>

<script>
import NavbarMain from './components/Navbars/Navbar.Main.vue'

import { Plugins } from '@capacitor/core';
const { SplashScreen } = Plugins;

export default {
  name: 'App',
  components: {
    NavbarMain
  },
  created(){
    SplashScreen.hide();
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
} */
</style>
